require('../sass/priceTable.scss');
require('../sass/packageTmpl.scss');


const
	initTips 	= require('./hotelPriceTableTips.js').initTips,
	packageTmpl = require('../templates/packageTmpl.ejs'),


	// 获取价格是否显示的 bool 值， true 表示要显示， false 表示不要显示
	// immediate:       XS-1 立即确认     XS-2 60秒确认   XS-0 待查
	// canceltype：     canceltype-0 可取消     canceltype-1 不可取消
	// bedbreakfast：   bedbreakfast-0 可加早     bedbreakfast-1 可加床
	getIsShowBoolean = function(priceObj, frontEndParams){
		var
			subIsShow1 = true,
			subIsShow2 = true,
			subIsShow3 = true,
			subIsShow4 = true,
			subIsShow5 = false,
			subIsShow6 = true,
			subIsShow7 = true,

			// 价格区间过滤（酒店详情页）
			price1 = +$("#slp_1").val() || 0.01,
			price2 = +$("#slp_2").val() || 999999999,
			avePrice = priceObj.averagePriceRMB;

		// 确认时间
		if( frontEndParams.immediate ){
			subIsShow1 = false;

			if( ~frontEndParams.immediate.indexOf('XS-0') ){
				subIsShow1 |= (priceObj.roomStatus === 2);
			}

			if( ~frontEndParams.immediate.indexOf('XS-1') ){
				subIsShow1 |= (priceObj.isTimeLimitConfirSupplier === 0 && priceObj.confirm === true && priceObj.roomStatus != 3);
			}

			if( ~frontEndParams.immediate.indexOf('XS-2') ){
				subIsShow1 |= (priceObj.isTimeLimitConfirSupplier === 1);
			}
		}

		// 可否取消
		if( frontEndParams.canceltype ){
			subIsShow2 = false;

			if( ~frontEndParams.canceltype.indexOf('canceltype-0') ){
				subIsShow2 |= (priceObj.isCanCancle === 1);		// cancellationType --> isCanCancle
			}

			if( ~frontEndParams.canceltype.indexOf('canceltype-1') ){
				subIsShow2 |= (priceObj.isCanCancle !== 1);		// cancellationType --> isCanCancle
			}
		}

		// 加床、加早
		if( frontEndParams.bedbreakfast ){
			if( ~frontEndParams.bedbreakfast.indexOf('bedbreakfast-0') ){
				subIsShow3 &= (priceObj.isHasSurchargeBref === 1);
			}

			if( ~frontEndParams.bedbreakfast.indexOf('bedbreakfast-1') ){
				subIsShow3 &= (priceObj.isHasSurchargeBed === 1);
			}
		}

		// 价格区间
		if( frontEndParams.priceRange ){
			subIsShow4 = false;

			var priceRangeArr = frontEndParams.priceRange.split(',');
			for(var i = 0; i < priceRangeArr.length; i++){
				var p1 = +priceRangeArr[i].split('-')[0] || 1;	// 避免价格为0的被选上
				var p2 = +priceRangeArr[i].split('-')[1] || 1;	// 避免价格为0的被选上

				subIsShow4 |= ( p1 <= avePrice && avePrice <= p2 );
			}
		}

		// 价格区间筛选（酒店详情页的 最低价、最高价）
		subIsShow5 |= ( price1 <= avePrice && avePrice <= price2 );

		// 只显示可订
		if( frontEndParams.isbook ){
			subIsShow5 = false;
			subIsShow5 |= priceObj.isBook;
		}

		// 含早
		if( frontEndParams.isHasBreakFast ){
			subIsShow7 = false;
            if(priceObj.rateTypeName == 'Drinking water' || priceObj.rateTypeName == 'Room only' ) {    //如果isHasBreakFast为1代表含早,为0代表不含早。例外：rateTypeName = Room only 或 rateTypeName = Drinking water 也是不含早
                priceObj.isHasBreakFast = 0
            }
			subIsShow7 |= priceObj.isHasBreakFast;
		}

		return subIsShow1 && subIsShow2 && subIsShow3 && subIsShow4 && subIsShow5 && subIsShow6 && subIsShow7;
	},

	// 分别为 'roomTypeBasesRecommend' 和 'roomTypeBases' 过滤数据
	filterDataForEachType = function(list, frontEndParams){
		if( !list ) return;
		var rowSpan = 0;

		for (var i = 0; i < list.length; i++) {
			var o = list[i];

			for (var j = 0; j < o.roomTypePrices.length; j++) {
				var p = o.roomTypePrices[j];
				var isShow = getIsShowBoolean(p, frontEndParams);
				if( !isShow ){
					o.roomTypePrices.splice(j--, 1);
				}

				// if(p.supplierId === '40192' || p.supplierId === '40095' || p.supplierId === '163987'){
				// 	if(p.bedTypeList.length > 1){
				// 		p.bedTypeNameAddOn = '(尽量安排)'
				// 	}
				// }else{
				// 	p.bedTypeNameAddOn = ''
				// }
			}

			rowSpan += o.roomTypePrices.length;

			if( o.roomTypePrices.length < 1 ){
				list.splice(i--, 1);
			}
		}

		list.rowSpan = rowSpan;
	},

	// 获取前端的参数
	getFrontEndParams = function(){
		var
			params = {},
			immediateArr = $("input[data-attr='immediate']:checked"),
			canceltypeArr = $("input[data-attr='canceltype']:checked"),
			bedbreakfastArr = $("input[data-attr='bedbreakfast']:checked"),
			priceRangeArr = $("input[data-attr='priceRange']:checked"),
			immediateStr = [],
			canceltypeStr = [],
			bedbreakfastStr = [],
			priceRangeStr = [],

			isHasBreakFastStr = $("input[data-attr='isHasBreakFast']:checked").attr('data-value'),
			isbookStr = $("input[data-attr='isbook']:checked").attr('data-value');


		for (var i = 0; i < immediateArr.length; i++)	immediateStr.push( $(immediateArr[i]).attr('data-value') );
		for (var i = 0; i < canceltypeArr.length; i++)	canceltypeStr.push( $(canceltypeArr[i]).attr('data-value') );
		for (var i = 0; i < bedbreakfastArr.length; i++)	bedbreakfastStr.push( $(bedbreakfastArr[i]).attr('data-value') );
		for (var i = 0; i < priceRangeArr.length; i++)	priceRangeStr.push( $(priceRangeArr[i]).attr('data-value') );

		if( immediateStr.length )		params.immediate = immediateStr.join(',');
		if( canceltypeStr.length )		params.canceltype = canceltypeStr.join(',');
		if( bedbreakfastStr.length )	params.bedbreakfast = bedbreakfastStr.join(',');
		if( priceRangeStr.length )		params.priceRange = priceRangeStr.join(',');
		if( isHasBreakFastStr )			params.isHasBreakFast = isHasBreakFastStr;
		if( isbookStr )					params.isbook = isbookStr;

		return params;
	},

	goToOrderConfirmPage = function (_this) {
		var nightlyPriceList = JSON.parse(_this.find('.nightlyPriceList').html())
		var ifInvoice = nightlyPriceList && nightlyPriceList[0] && nightlyPriceList[0].ifInvoice
		var
			priceStrs = _this.find('.hotelPriceStrs'),
			priceStrs_key = "hotelPriceStrs_" + (+new Date()),
			params = [
				'staticInfoId=' 		+ _this.attr('data-hotelid'),
				'hotelId=' 				+ _this.attr('data-hotelid'),
				'supplierId=' 			+ _this.attr('data-supplierid'),
				'roomId=' 				+ _this.attr('data-roomId'),
				'breakFastId=' 			+ _this.attr('data-breakFastId'),
				'paymentType=' 			+ _this.attr('data-paymentType'),
				'rateType=' 			+ _this.attr('data-rateType'),
				'arriveStartTime=' 		+ _this.attr('data-arriveStartTime'),
				'arriveEndTime=' 		+ _this.attr('data-arriveEndTime'),
                'checkOutTime=' 		+ _this.attr('data-checkOutTime'),

				'isQueryPrice=true',
				_this.attr('data-marketingStr'),

				'startDate=' 			+ $.queryingHotelParams.startDate,
				'endDate=' 				+ $.queryingHotelParams.endDate,
				'citytype=' 			+ $.queryingHotelParams.type || '0',
				'adultNum=' 			+ $.queryingHotelParams.adultNum,
				'childrenNum=' 			+ $.queryingHotelParams.childrenNum,
				'childrenAgeStr=' 		+ $.queryingHotelParams.childrenAgesStr,
				'roomNum=' 				+ $.queryingHotelParams.selRoomNum,
				'ch=' 					+ $.queryingHotelParams.type || '0',
				'hotelPriceStrsKey=' 	+ priceStrs_key,
            	'isTicket=' 	        + ((!ifInvoice || ifInvoice === 1 || ifInvoice === 3) ? 0 : 1)
			];

		sessionStorage.setItem(priceStrs_key, priceStrs.html());

        /**
         * 保存EAN供应商需要的入住政策
         */
        let $hotelPolicies = $(".hotelPolicies");
        if($hotelPolicies && $hotelPolicies.html()) {
            sessionStorage.setItem(`${priceStrs_key}_policies`, window.JSON.stringify($hotelPolicies.html()));
        }

        /**
         * 保存EAN供应商需要的强制性费用和可选费用
         */
        let $fees_mandatory = $(".fees_mandatory");
        if($fees_mandatory && $fees_mandatory.html()) {
            sessionStorage.setItem(`${priceStrs_key}_mandatory`, window.JSON.stringify($fees_mandatory.html()));
        }
        let $fees_optional = $(".fees_optional");
        if($fees_optional && $fees_optional.html()) {
            sessionStorage.setItem(`${priceStrs_key}_optional`, window.JSON.stringify($fees_optional.html()));
        }


		//*** */
		var url = "/order/orderConfirm.do?" + params.join('&');
		//var url = "./orderConfirm.html?" + params.join('&');

		return url;
	},

	// 初始化表格中每一行中的td的鼠标移入事件
	initTdMouseEnter = function (_table) {
		_table.find('td').not('.first-td').on('mouseenter', function () {
			$(this).closest('tr').find('td').not('.first-td').addClass('td-hover');
        }).on('mouseleave', function () {
            $(this).closest('tr').find('td').not('.first-td').removeClass('td-hover');
        })
    }

	// 初始化 "预订" 按钮点击事件
	initOrderClick = function(_table){
		_table.find('.hp-order-btn').not('.disabled').on('click', function(){
                console.log('=====');
			var _this = $(this);

		//	当有 package 标识时，弹出框
			// if( _this.closest('tr').find('.pagekage-icon').length > 0 ){
			// 	var index = layer.open({
			// 		title: '提示信息',
			// 		area: '500px',
			// 		content: packageTmpl({link: goToOrderConfirmPage(_this)}),
			// 		btn: []
			// 	});
			// }else{
				_this.attr("href", goToOrderConfirmPage(_this));
			// }
		});

		// 初始化 package 加价弹出框 输入航班号事件
		$(document).delegate('.hli-package-input', 'input paste keyup', function(){
			var _this = $(this);
			var value = _this.val().replace(/^\s+|\s+$/g, '')
			var	nextClickBtn = _this.closest('.hli-package-confirm-wrap').find('.hli-package-btn');
			var rule = /.*[^\s]/  // /^[A-Z]{2}\d{4}$/g

			rule.test(value)
				? nextClickBtn.removeClass('disabled')
				: nextClickBtn.addClass('disabled');
		});

		// 初始化 package 加价弹出框点击按钮事件
		$(document).delegate('.hli-package-btn', 'click', function(){
			if ($(this).hasClass('disabled')){
				var	warningInfo = $(this).closest('.hli-package-confirm-wrap').find('.warning-info');
				warningInfo.removeClass('hidden')

				setTimeout(function(){
				  warningInfo.addClass('hidden')
				}, 2000)

				return false;
			}

			layer.closeAll();
		});
	};

	
    
    // 初始化房型名称的点击事件 - 在酒店列表页和详情页使用了
	const initRoomTypeNameClick = function(_table){
        let url = $.pageFrom;
        if(url && url == 'hotelDetail') {   //在详情页触发
            _table.find(".show-more-td2").on("click", function() {

                var _this = $(this);  //当前元素
                var typeText = _this.attr('data-type');   //index === 0 ? 'recommend' : 'others'
                var typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']');  //所有tr的第一个td
                var spanRow = +typeTd.attr('rowspan');  //通常使用在td与th标签中，可以实现表格中一列跨越多行
                var thisTd = _this.closest('td');     //当前td
                var dragIcon = _this.find('.room-type-icon');    //当前icon
                var childIcon = _this.closest('tr').find('.room-type-icon');   //当前icon
                var dataIndex = _this.attr('data-index');
                var sameRoomTypeTr;
                var sameRoomTypeTrs = [];

                if(dragIcon.length){

                    if(dragIcon.hasClass('room-type-down')){       //展开更多价格
                        $(".borderTr" + dataIndex).removeClass('click-btn-css');
                        $(this).find('span').html('收起');
                        dragIcon.removeClass('room-type-down').addClass('room-type-up');
                    }else{
                        $(".borderTr" + dataIndex + ":gt(2)").addClass('click-btn-css');
                        $(this).find('span').html('更多价格');
                        dragIcon.removeClass('room-type-up').addClass('room-type-down');

                        //耗时0.5秒时间，滑动到指定元素（动效）
                        $('html,body').animate({
                            scrollTop : $(".firstBorderTr" + dataIndex).offset().top - 90
                        }, 200);
                    }
                }
            })

        } else {        //在列表页触发
            _table.find(".hp-roomName").on('click', function(){
                var _this = $(this),
                    typeText = _this.attr('data-type'),
                    typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']'),
                    spanRow = +typeTd.attr('rowspan'),
                    thisTd = _this.closest('td'),
                    dragIcon = _this.find('.room-type-icon'),
                    sameRoomTypeTr, sameRoomTypeTrs = [];
    
                if(dragIcon.length){
                    sameRoomTypeTr = _this.closest('tr').next('.auto-hide-tr');
    
                    while(sameRoomTypeTr.length){
                        sameRoomTypeTrs.push(sameRoomTypeTr);
                        sameRoomTypeTr = sameRoomTypeTr.next('.auto-hide-tr');
                    }
    
                    if(dragIcon.hasClass('room-type-down')){
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').removeClass('hidden');
                            }, 50);
    
                            $(o).slideDown('fast');
                        });
    
                        setTimeout(function(){
                            dragIcon.removeClass('room-type-down').addClass('room-type-up');
                        }, 50);
    
                        if(typeText === 'recommend'){
                            typeTd.attr('rowspan', spanRow + sameRoomTypeTrs.length);
                        }
    
                        thisTd.removeClass('force-border');
                    }else{
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').addClass('hidden');
                            }, 80);
    
                            $(o).slideUp('fast');
                        });
    
                        setTimeout(function(){
                            dragIcon.removeClass('room-type-up').addClass('room-type-down');
    
                            if(typeText === 'recommend'){
                                typeTd.attr('rowspan', spanRow - sameRoomTypeTrs.length);
                            }
                        }, 80);
    
                        thisTd.addClass('force-border');
                    }
                }
            })
        }
	},



	// 初始化房型名称的点击事件 - 老的,在第二个td的按钮
    /** 
	const initRoomTypeNameClick = function(_table){
        //console.log('_table11',$.pageFrom);
		_table.find(".hp-roomName").on('click', function(){
            //console.log('_table222',$.pageFrom);
            //console.log('=location=',window.location.href);
            let url = $.pageFrom;
            if(url && url == 'hotelDetail') {    //在酒店详情页触发的事件
                
                var _this = $(this),
				typeText = _this.attr('data-type'),
				typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']'),
				spanRow = +typeTd.attr('rowspan'),
				thisTd = _this.closest('td'),
				dragIcon = _this.find('.room-type-icon'),
				childIcon = _this.closest('tr').find('.room-type-icon'),
				sameRoomTypeTr, sameRoomTypeTrs = [];
                //  auto-hide-tr :每个数组里,除了第一条数据,其他tr都有
                // auto-hide:  tr 下标大于5的tr
                if(dragIcon.length){

                    if(dragIcon.hasClass('room-type-down')){
                        //console.log('我执行了显示');
                        $(this).find('span').html('收起')
    
                        sameRoomTypeTrs = []  //列表清空
                        sameRoomTypeTr = _this.closest('tr').next('.auto-hide-tr');//找到当前数组下面的tr
                        while(sameRoomTypeTr.length){   //循环遍历,加入列表
                            sameRoomTypeTrs.push(sameRoomTypeTr);
                            sameRoomTypeTr = sameRoomTypeTr.next('.auto-hide-tr');
                        }
    
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').removeClass('hidden');
                            }, 50);
    
                            $(o).slideDown('fast');
                        });
                        
                        _this.closest('tr').attr('data-show','true');   //当前项的自定义show-btn设为true
                        $(this).addClass('hidden');
                        let showTr = _this.closest('tr').nextAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.new-btn');
    
                         //找到元素span-title,定义变量,为其根据文字长度控制高度
                         let spanTitle = _this.closest('tr').nextAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.span-title')
                         let spanTitleLength = _this.closest('tr').nextAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.span-title').html().length
                         if(spanTitleLength>13 && spanTitleLength<=26 ){
                             // console.log(111);
                             $(spanTitle).css({
                                 height:'92px'
                             })
                         } else if(spanTitleLength>26 && spanTitleLength<=39) {
                             // console.log(222);
                             $(spanTitle).css({
                                 height:'95px',
                                 alignItems: 'start',
                                 paddingTop:'7px'
                             })
                         }  else {
                             
                         }
    
                        $(showTr).removeClass('hidden')
                        $(showTr).find('span').html('收起');
                        $(showTr).find('.room-type-icon').removeClass('room-type-down').addClass('room-type-up');
                        
                        setTimeout(function(){
                            childIcon.removeClass('room-type-down').addClass('room-type-up');
                        }, 50);
    
                        if(typeText === 'recommend'){
                            typeTd.attr('rowspan', spanRow + sameRoomTypeTrs.length);
                        }
    
                        thisTd.removeClass('force-border');
                    }else{
                        sameRoomTypeTrs = []   //列表清空
                        sameRoomTypeTrs.push(_this.closest('tr'))	//当前项tr也要加入列表
                        sameRoomTypeTr = _this.closest('tr').prev('.auto-hide-tr'); //找到当前项上面的tr
                        while(sameRoomTypeTr.length){    //遍历加入列表
                            sameRoomTypeTrs.push(sameRoomTypeTr);
                            sameRoomTypeTr = sameRoomTypeTr.prev('.auto-hide-tr');
                        }
                        
    
                        $(this).find('span').html('更多')
                        //console.log('我执行了隐藏',sameRoomTypeTrs);
                        
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').addClass('hidden');
                            }, 80);
                            $(o).slideUp('fast');
                        });
    
                        // return
                        window.setTimeout(()=>{
                            //显示父级tr的更多(td)
                            let showTr = _this.closest('tr').prevAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.new-btn');
                            
                            //找到元素span-title,定义变量,为其根据文字长度控制高度
                            let spanTitle = _this.closest('tr').prevAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.span-title')
                            let spanTitleLength = _this.closest('tr').prevAll('.hotel-price-tr[data-show=' +'true' + ']:eq(0)').find('.span-title').html().length
                            if(spanTitleLength>13 && spanTitleLength<=26 ){
                                $(spanTitle).css({
                                    height:'80px'
                                })
                            } else if(spanTitleLength>26 && spanTitleLength<=39) {
                                $(spanTitle).css({
                                    height:'82px',
                                    alignItems: 'start',
                                    paddingTop:'7px'
                                })
                            }  else {
                                
                            }
    
                            $(showTr).removeClass('hidden');
                            $(showTr).find('span').html('更多');
                            $(showTr).find('.room-type-icon').removeClass('room-type-up').addClass('room-type-down'); 
                        },80)
                        
    
                        setTimeout(function(){
                            childIcon.removeClass('room-type-up').addClass('room-type-down');
    
                            if(typeText === 'recommend'){
                                typeTd.attr('rowspan', spanRow - sameRoomTypeTrs.length);
                            }
                        }, 80);
    
                        thisTd.addClass('force-border');
                    }
                }

            } else {        //在酒店列表页触发的事件
                var _this = $(this),
				typeText = _this.attr('data-type'),
				typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']'),
				spanRow = +typeTd.attr('rowspan'),
				thisTd = _this.closest('td'),
				dragIcon = _this.find('.room-type-icon'),
				sameRoomTypeTr, sameRoomTypeTrs = [];
                if(dragIcon.length){
                    sameRoomTypeTr = _this.closest('tr').next('.auto-hide-tr');
    
                    while(sameRoomTypeTr.length){
                        sameRoomTypeTrs.push(sameRoomTypeTr);
                        sameRoomTypeTr = sameRoomTypeTr.next('.auto-hide-tr');
                    }
    
                    if(dragIcon.hasClass('room-type-down')){
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').removeClass('hidden');
                            }, 50);
    
                            $(o).slideDown('fast');
                        });
    
                        setTimeout(function(){
                            dragIcon.removeClass('room-type-down').addClass('room-type-up');
                        }, 50);
    
                        if(typeText === 'recommend'){
                            typeTd.attr('rowspan', spanRow + sameRoomTypeTrs.length);
                        }
    
                        thisTd.removeClass('force-border');
                    }else{
                        $.each(sameRoomTypeTrs, function(i, o) {
                            setTimeout(function(){
                                $(o).find('td').addClass('hidden');
                            }, 80);
    
                            $(o).slideUp('fast');
                        });
    
                        setTimeout(function(){
                            dragIcon.removeClass('room-type-up').addClass('room-type-down');
    
                            if(typeText === 'recommend'){
                                typeTd.attr('rowspan', spanRow - sameRoomTypeTrs.length);
                            }
                        }, 80);
    
                        thisTd.addClass('force-border');
                    }
                }
            }
			
			
		})
	},
    */
	

	// 根据前端的一些参数对要显示的价格进行进一步过滤，如 "确认时间"、"可否取消"、"加床加早" 等，然后再将数据填充到页面，并初始化一些事件
	filterPriceAndFillIntoTable = function(priceTableTmpl, _table, firstQuery){
		var tableList = _table || $(".hli-expand-inner");
		for (var i = 0; i < tableList.length; i++) {
			var item = tableList[i];

			var
				priceList = $.extend(true, {}, item.priceList),		// 深拷贝，不影响原来的数据，因为原数据后续还要用
				wraper = $(item).closest('.hl-item').find('.hli-price-list-wrap'),
				frontEndParams = getFrontEndParams(),
				noPriceMsg = '<div class="hli-error-msg">无相关价格！</div>',
				_table;

			if( item.priceList ){
				// 过滤数据
				filterDataForEachType(priceList.roomTypeBasesRecommend, frontEndParams);
				filterDataForEachType(priceList.roomTypeBases, frontEndParams);

				// 填充数据，并初始化 tips，如果是第一次查价且没有价格时，则先不显示无价提示信息，等第二次查价再作判断
				if( (!priceList.roomTypeBasesRecommend || !priceList.roomTypeBasesRecommend.length) &&
					(!priceList.roomTypeBases || !priceList.roomTypeBases.length) && !firstQuery ){
					wraper.html(noPriceMsg);
				}else{
					if( !priceList.roomTypeBasesRecommend )	priceList.roomTypeBasesRecommend = [];
					if( !priceList.roomTypeBases )	priceList.roomTypeBases = [];

                    try {
                        const urlParams = new URLSearchParams(window.location.search);
                        const paramValue = urlParams.get("ch");
                        priceList.ch = paramValue;
                    } catch (error) {
                        console.log("error", error);
                        priceList.ch = 1;
                    }
                    
					_table = $(priceTableTmpl(priceList));
					wraper.html(_table);

					// 针对详情页首次渲染超过5行的隐藏
					// _table.find('.auto-hide').hide();
					// _table.find('.auto-hide td').addClass('hidden');

					initTips(_table);
                    initTdMouseEnter(_table);
					initOrderClick(_table);
					initRoomTypeNameClick(_table);
				}
			}else{
				if( !firstQuery ){
					wraper.html(noPriceMsg);
				}
			}
		}
	};



// 前端条件过滤酒店价格，条件有 "确认时间"、"可否取消"、"加床加早"
module.exports = filterPriceAndFillIntoTable;



// WEBPACK FOOTER //
// ./src/common/hotelPriceUtil/modules/filterPriceAndFillIntoTable.js